
import RcDomainObject from "@/domain/common/RcDomainObject";

import Vehicle from "./Vehicle.js";
import VehicleMap from "./VehicleMap.js";
import VehicleDataDomain from "./data/VehicleDataDomain.js";

export default class VehiclesDomain extends RcDomainObject {
    
  constructor(domain, storage, dataStorage) {
    super(domain);
    this.storage = storage;
    this._data = new VehicleDataDomain(domain, dataStorage);
  }

  // The latest values recorded against assets - odometers, meter readings.
  // Not named data(): RcObject already uses a `data` property for an
  // object's JSON backing, which would shadow the method.
  vehicleData() {
    return this._data;
  }
  
  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Vehicle(this.domain, item);
      }
    }

    var vehicle = new Vehicle(this.domain);
    vehicle.withId(objId);
    return vehicle;
  }

  findByCompany(company) {
    var map = new VehicleMap(this.domain);
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      let vehicle = new Vehicle(this.domain, item);
      if (vehicle.company().id() === company.id()) {
        map.add(vehicle);
      }
    }
    return map;
  }
}